<template>
	<div>
		<loader v-if="!activeItem"/>
		<template v-else>
			<header class="flex-apart">
				<div>
					<h1 class="alpha heavy">Missed Lead</h1>
				</div>
			</header>
			<div class="sections">
				<section class="section--floating section--flexed">
					<h2 class="beta">Contact Information</h2>
					{{ activeItem }}
					<!--					<dl class="mt-1 flex gap-2">-->
					<!--						<div>-->
					<!--							<div>-->
					<!--								<dt class="heavy">Email</dt>-->
					<!--								<dd v-if="!activeItem.email">—</dd>-->
					<!--								<dd v-else v-html="activeItem.email"/>-->
					<!--							</div>-->
					<!--							<div class="mt-1">-->
					<!--								<dt class="heavy">Phone Number</dt>-->
					<!--								<dd v-if="!activeItem.phone">—</dd>-->
					<!--								<dd v-else v-html="activeItem.phone"/>-->
					<!--							</div>-->
					<!--						</div>-->
					<!--						<div>-->
					<!--							<div>-->
					<!--								<dt class="heavy">Correspondence Address</dt>-->
					<!--								<dd v-if="!activeItem.group.correspondenceAddress">—</dd>-->
					<!--								<Address v-else :address="activeItem.group.correspondenceAddress"/>-->
					<!--							</div>-->
					<!--							<div v-if="activeItem.group.primaryContact.id !== activeItem.id">-->
					<!--								<dt class="heavy">Primary Contact</dt>-->
					<!--								<dd class="mt-1">-->
					<!--									<router-link-->
					<!--										:to="{name: 'clients.show', params: {client: activeItem.group.primaryContact.id}}"-->
					<!--										v-html="$present('clientName', activeItem.group.primaryContact)"/>-->
					<!--								</dd>-->
					<!--							</div>-->
					<!--						</div>-->
					<!--					</dl>-->
				</section>
			</div>
		</template>
	</div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import Address from "../../../../components/Address";

export default {
	components: {
		Address,
	},

	computed: {
		...mapGetters("missedLeads", [
			"activeItem",
		]),
	},

	methods: {
		...mapActions("missedLeads", [
			"activateModel",
		]),
		showAssignModal(missedLead) {
			this.$vmodal.open({
				component: require("./modals/Assign.vue").default,
				props: {
					missedLead: missedLead,
				},
			});
		},
	},
};
</script>
